module.exports = __webpack_public_path__ + "95b4641654bf1f46893023057c775433.pdf";